import React from 'react';

import StorageSvg from 'assets/images/storage.svg';

import BaseIcon from './BaseIcon';

const StorageIcon = props => <BaseIcon {...props} src={StorageSvg} />;

export default StorageIcon;
